// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.WellnessPlanModule-module__font-s-10___tBTln {
  font-size: 10px !important;
}

.WellnessPlanModule-module__font-s-12___Lkike {
  font-size: 12px !important;
}

.WellnessPlanModule-module__font-s-13___EF7H5 {
  font-size: 13px !important;
}

.WellnessPlanModule-module__font-s-14___nkE56 {
  font-size: 14px !important;
}

.WellnessPlanModule-module__font-s-15___tuTEb {
  font-size: 15px !important;
}

.WellnessPlanModule-module__font-s-16___aq9mj {
  font-size: 16px !important;
}

.WellnessPlanModule-module__font-s-18___eFy8W {
  font-size: 18px !important;
}

.WellnessPlanModule-module__font-s-20___AveBw {
  font-size: 20px !important;
}

.WellnessPlanModule-module__font-s-22___p1LMj {
  font-size: 22px !important;
}

.WellnessPlanModule-module__font-s-28___UC2Om {
  font-size: 28px !important;
}

.WellnessPlanModule-module__font-w-400___vyLkJ {
  font-weight: 400 !important;
}

.WellnessPlanModule-module__font-w-500___njaAD {
  font-weight: 500 !important;
}

.WellnessPlanModule-module__font-w-600___dtQvt {
  font-weight: 600 !important;
}

.WellnessPlanModule-module__font-w-700___o0OTS {
  font-weight: 700 !important;
}

.WellnessPlanModule-module__p-5___K2kO3 {
  padding: 5px !important;
}

.WellnessPlanModule-module__p-12___Xg3oz {
  padding: 12px !important;
}

.WellnessPlanModule-module__p-16___isjL5 {
  padding: 16px !important;
}

.WellnessPlanModule-module__p-30___JpzYP {
  padding: 30px !important;
}

.WellnessPlanModule-module__p-b-0___v5YR0 {
  padding-bottom: 0 !important;
}

.WellnessPlanModule-module__p-b-5___aicqI {
  padding-bottom: 5px !important;
}

.WellnessPlanModule-module__p-b-10___ihSW9 {
  padding-bottom: 10px !important;
}

.WellnessPlanModule-module__p-b-12___oQRSM {
  padding-bottom: 12px !important;
}

.WellnessPlanModule-module__p-b-16___zF_OH {
  padding-bottom: 16px !important;
}

.WellnessPlanModule-module__p-b-18___ig4ku {
  padding-bottom: 18px !important;
}

.WellnessPlanModule-module__p-b-20___bIMD0 {
  padding-bottom: 20px !important;
}

.WellnessPlanModule-module__p-b-25___aC5nK {
  padding-bottom: 25px !important;
}

.WellnessPlanModule-module__p-b-30___D948J {
  padding-bottom: 30px !important;
}

.WellnessPlanModule-module__p-b-50___dB07H {
  padding-bottom: 50px !important;
}

.WellnessPlanModule-module__p-t-0___uRlov {
  padding-top: 0 !important;
}

.WellnessPlanModule-module__p-t-12___Mm6dg {
  padding-top: 12px !important;
}

.WellnessPlanModule-module__p-t-16___o3ktI {
  padding-top: 16px !important;
}

.WellnessPlanModule-module__p-t-18___W_tMr {
  padding-top: 18px !important;
}

.WellnessPlanModule-module__p-t-20___R4yAa {
  padding-top: 20px !important;
}

.WellnessPlanModule-module__p-t-30___NHiQP {
  padding-top: 30px !important;
}

.WellnessPlanModule-module__p-t-40___UzToZ {
  padding-top: 40px !important;
}

.WellnessPlanModule-module__p-t-50___B9aSC {
  padding-top: 50px !important;
}

.WellnessPlanModule-module__p-l-20___xU0d2 {
  padding-left: 20px !important;
}

.WellnessPlanModule-module__p-l-30___KaGYR {
  padding-left: 30px !important;
}

.WellnessPlanModule-module__p-l-40___gM3em {
  padding-left: 40px !important;
}

.WellnessPlanModule-module__p-r-16___v9G3B {
  padding-right: 16px !important;
}

.WellnessPlanModule-module__p-r-20___xsgpc {
  padding-right: 20px !important;
}

.WellnessPlanModule-module__p-r-30___r88UJ {
  padding-right: 30px !important;
}

.WellnessPlanModule-module__p-r-50___d8qqB {
  padding-right: 50px !important;
}

.WellnessPlanModule-module__p-r-60___cz8UQ {
  padding-right: 60px !important;
}

.WellnessPlanModule-module__m-b-1___qpXRu {
  margin-bottom: 1px !important;
}

.WellnessPlanModule-module__m-b-2___pCRd_ {
  margin-bottom: 2px !important;
}

.WellnessPlanModule-module__m-b-6___R3QPb {
  margin-bottom: 6px !important;
}

.WellnessPlanModule-module__m-b-8____ncu1 {
  margin-bottom: 8px !important;
}

.WellnessPlanModule-module__m-b-10___fprV1 {
  margin-bottom: 10px !important;
}

.WellnessPlanModule-module__m-b-14___I7vbQ {
  margin-bottom: 14px !important;
}

.WellnessPlanModule-module__m-b-16___m42ix {
  margin-bottom: 16px !important;
}

.WellnessPlanModule-module__m-b-20___vA3e5 {
  margin-bottom: 20px !important;
}

.WellnessPlanModule-module__m-b-22___ywKSi {
  margin-bottom: 22px !important;
}

.WellnessPlanModule-module__m-b-24___UPv7P {
  margin-bottom: 24px !important;
}

.WellnessPlanModule-module__m-b-30___tPTuY {
  margin-bottom: 30px !important;
}

.WellnessPlanModule-module__m-b-32___MNVug {
  margin-bottom: 32px !important;
}

.WellnessPlanModule-module__m-b-40___siCFR {
  margin-bottom: 40px !important;
}

.WellnessPlanModule-module__m-t-2___Sn104 {
  margin-top: 2px !important;
}

.WellnessPlanModule-module__m-t-3___NoTMD {
  margin-top: 3px !important;
}

.WellnessPlanModule-module__m-t-4___r5PYo {
  margin-top: 4px !important;
}

.WellnessPlanModule-module__m-t-5___lBDnz {
  margin-top: 5px !important;
}

.WellnessPlanModule-module__m-t-8___QCn6X {
  margin-top: 8px !important;
}

.WellnessPlanModule-module__m-t-10___k7nnE {
  margin-top: 10px !important;
}

.WellnessPlanModule-module__m-t-15___S_ZVP {
  margin-top: 15px !important;
}

.WellnessPlanModule-module__m-t-16___HKICM {
  margin-top: 16px !important;
}

.WellnessPlanModule-module__m-t-20___uO9Zt {
  margin-top: 20px !important;
}

.WellnessPlanModule-module__m-t-22___cTp0A {
  margin-top: 22px !important;
}

.WellnessPlanModule-module__m-t-30___wOyC5 {
  margin-top: 30px !important;
}

.WellnessPlanModule-module__m-t-32___KJ5WX {
  margin-top: 32px !important;
}

.WellnessPlanModule-module__m-l-auto___YXT_a {
  margin-left: auto !important;
}

.WellnessPlanModule-module__m-l-4___Lo68e {
  margin-left: 4px !important;
}

.WellnessPlanModule-module__m-l-5___I_P_P {
  margin-left: 5px !important;
}

.WellnessPlanModule-module__m-l-6___EOug_ {
  margin-left: 6px !important;
}

.WellnessPlanModule-module__m-l-8___orrF5 {
  margin-left: 8px !important;
}

.WellnessPlanModule-module__m-l-10___mkkXA {
  margin-left: 10px !important;
}

.WellnessPlanModule-module__m-l-16___KdQSI {
  margin-left: 16px !important;
}

.WellnessPlanModule-module__m-l-20___UFur0 {
  margin-left: 20px !important;
}

.WellnessPlanModule-module__m-l-24___dSJAd {
  margin-left: 24px !important;
}

.WellnessPlanModule-module__m-l-30___gZYlH {
  margin-left: 30px !important;
}

.WellnessPlanModule-module__m-l-35___L96EO {
  margin-left: 35px !important;
}

.WellnessPlanModule-module__m-l-40___lZDsN {
  margin-left: 40px !important;
}

.WellnessPlanModule-module__m-r-8___cy1o8 {
  margin-right: 8px !important;
}

.WellnessPlanModule-module__m-r-10___sjtIz {
  margin-right: 10px !important;
}

.WellnessPlanModule-module__m-r-16___tjYBg {
  margin-right: 16px !important;
}

.WellnessPlanModule-module__m-r-20___N2koR {
  margin-right: 20px !important;
}

.WellnessPlanModule-module__m-r-24___Y1ume {
  margin-right: 24px !important;
}

.WellnessPlanModule-module__m-r-30___mCqXq {
  margin-right: 30px !important;
}

.WellnessPlanModule-module__m-r-40___ErCls {
  margin-right: 40px !important;
}

.WellnessPlanModule-module__border-r-3___C_bGj {
  border-radius: 3px !important;
}

.WellnessPlanModule-module__border-r-4___iYOme {
  border-radius: 4px !important;
}

.WellnessPlanModule-module__border-r-6___cJlr5 {
  border-radius: 6px !important;
}

.WellnessPlanModule-module__border-r-10___Ya0SH {
  border-radius: 10px !important;
}

.WellnessPlanModule-module__border-r-12___m_5uP {
  border-radius: 12px !important;
}

.WellnessPlanModule-module__border-r-16___FKa6g {
  border-radius: 16px !important;
}

.WellnessPlanModule-module__border-r-50___dgTVd {
  border-radius: 50% !important;
}

.WellnessPlanModule-module__primary-border___bA8ku {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlanModule-module__primary-border-b___gJaYG {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlanModule-module__primary-border-t___SlIIv {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlanModule-module__primary-border-l___hSH7A {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlanModule-module__primary-border-r___AjJI6 {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.WellnessPlanModule-module__secondary-border___ygeBC {
  border: 1px solid #637768;
}

.WellnessPlanModule-module__secondary-border-b___AQuhB {
  border-bottom: 1px solid #637768;
}

.WellnessPlanModule-module__secondary-border-t___G61p4 {
  border-top: 1px solid #637768;
}

.WellnessPlanModule-module__secondary-border-l___TmDay {
  border-left: 1px solid #637768;
}

.WellnessPlanModule-module__secondary-border-r___LLamk {
  border-right: 1px solid #637768;
}

.WellnessPlanModule-module__gap-0___bfDkh {
  gap: 0 !important;
}

.WellnessPlanModule-module__gap-2___yyjBC {
  gap: 2px !important;
}

.WellnessPlanModule-module__gap-4___Cq9J9 {
  gap: 4px !important;
}

.WellnessPlanModule-module__gap-5___FgNOs {
  gap: 5px !important;
}

.WellnessPlanModule-module__gap-6___uL5Cu {
  gap: 6px !important;
}

.WellnessPlanModule-module__gap-8___xzSk0 {
  gap: 8px !important;
}

.WellnessPlanModule-module__gap-10___EVwue {
  gap: 10px !important;
}

.WellnessPlanModule-module__gap-12___tR_wa {
  gap: 12px !important;
}

.WellnessPlanModule-module__gap-14___U4HOq {
  gap: 14px !important;
}

.WellnessPlanModule-module__gap-16___SwpkQ {
  gap: 16px !important;
}

.WellnessPlanModule-module__gap-18___eHfZJ {
  gap: 18px !important;
}

.WellnessPlanModule-module__gap-20___nd6dT {
  gap: 20px !important;
}

.WellnessPlanModule-module__gap-24___RfNlA {
  gap: 24px !important;
}

.WellnessPlanModule-module__gap-26___mF179 {
  gap: 26px !important;
}

.WellnessPlanModule-module__gap-30___BozC5 {
  gap: 30px !important;
}

.WellnessPlanModule-module__gap-32___tCErU {
  gap: 32px !important;
}

.WellnessPlanModule-module__gap-40___Fz9Dy {
  gap: 40px !important;
}

.WellnessPlanModule-module__gap-50___OpuOk {
  gap: 50px !important;
}

.WellnessPlanModule-module__flex-1___EC4J4 {
  flex: 1;
}

.WellnessPlanModule-module__flex-none___HB_pI {
  flex: none !important;
}

.WellnessPlanModule-module__flex-column___v0EHb {
  display: flex;
  flex-direction: column !important;
}

.WellnessPlanModule-module__flex-row___vHT_5 {
  display: flex;
  flex-direction: row !important;
}

.WellnessPlanModule-module__vertically-centered___TI5U9 {
  display: flex;
  align-items: center !important;
}

.WellnessPlanModule-module__horizontally-centered___FVGC_ {
  display: flex;
  justify-content: center !important;
}

.WellnessPlanModule-module__horizontally-end___zuij4 {
  display: flex;
  justify-content: end !important;
}

.WellnessPlanModule-module__vertically-start___P26L3 {
  display: flex;
  align-items: start !important;
}

.WellnessPlanModule-module__space-between___A1PEK {
  display: flex;
  justify-content: space-between !important;
}

.WellnessPlanModule-module__flex-wrap___W5bnd {
  flex-wrap: wrap !important;
}

.WellnessPlanModule-module__height-100___EuZjr {
  height: 100%;
}

.WellnessPlanModule-module__width-50___zhCZV {
  width: 50% !important;
}

.WellnessPlanModule-module__width-100___IjNmR {
  width: 100%;
}

.WellnessPlanModule-module__cursor-pointer___OKekO {
  cursor: pointer;
}

.WellnessPlanModule-module__cursor-not-allowed___EkPTt {
  cursor: not-allowed !important;
}

.WellnessPlanModule-module__absolute-centered___hQyCf {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.WellnessPlanModule-module__absolute___hnvE9 {
  position: absolute;
}

.WellnessPlanModule-module__relative___foZo6 {
  position: relative;
}

.WellnessPlanModule-module__fixed___jHmsd {
  position: fixed;
}

.WellnessPlanModule-module__visible___VhBv_ {
  opacity: 1;
}

.WellnessPlanModule-module__invisible___soK65 {
  opacity: 0;
}

.WellnessPlanModule-module__col-90___iHaNQ {
  width: 90% !important;
}

.WellnessPlanModule-module__col-auto___BvFhu {
  width: auto !important;
}

.WellnessPlanModule-module__medical-tabs___m8aFj {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.WellnessPlanModule-module__medical-table-new___GTqAa {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.WellnessPlanModule-module__medical-table-new___GTqAa:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.WellnessPlanModule-module__medical-table-new___GTqAa::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.WellnessPlanModule-module__medical-table-new___GTqAa::-webkit-scrollbar-track {
  display: none;
}
.WellnessPlanModule-module__medical-table-new___GTqAa.WellnessPlanModule-module__no-pagination___zBEA6 {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.WellnessPlanModule-module__medical-table-new___GTqAa.WellnessPlanModule-module__no-pagination___zBEA6:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.WellnessPlanModule-module__medical-table-new___GTqAa.WellnessPlanModule-module__no-pagination___zBEA6::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.WellnessPlanModule-module__medical-table-new___GTqAa.WellnessPlanModule-module__no-pagination___zBEA6::-webkit-scrollbar-track {
  display: none;
}

.WellnessPlanModule-module__medical-table-empty___GCN0P {
  padding: 14px 40px !important;
}

.WellnessPlanModule-module__icon-btn___VwKEg {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.WellnessPlanModule-module__search-icon___r50CQ {
  width: 24px;
  height: 24px;
  align-self: center;
}

.WellnessPlanModule-module__disable-select___MCb3U {
  user-select: none;
}

.WellnessPlanModule-module__break-word___TgAQB {
  word-break: break-word;
}

.WellnessPlanModule-module__popup-clear-btn___VR_R8 {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.WellnessPlanModule-module__scroll-m-b-20___OqDMY {
  scroll-margin-bottom: 20px;
}

.WellnessPlanModule-module__container___cb2X7 {
  color: #375844;
  padding: 14px 30px 0 0;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/pages/DocumentationIndex/modules/WellnessPlanModule/WellnessPlanModule.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,cAAA;EACA,sBAAA;AA8pBF","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  color: get-color(greenNew, dark);\n  padding: 14px 30px 0 0;\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `WellnessPlanModule-module__font-s-10___tBTln`,
	"fontS12": `WellnessPlanModule-module__font-s-12___Lkike`,
	"fontS13": `WellnessPlanModule-module__font-s-13___EF7H5`,
	"fontS14": `WellnessPlanModule-module__font-s-14___nkE56`,
	"fontS15": `WellnessPlanModule-module__font-s-15___tuTEb`,
	"fontS16": `WellnessPlanModule-module__font-s-16___aq9mj`,
	"fontS18": `WellnessPlanModule-module__font-s-18___eFy8W`,
	"fontS20": `WellnessPlanModule-module__font-s-20___AveBw`,
	"fontS22": `WellnessPlanModule-module__font-s-22___p1LMj`,
	"fontS28": `WellnessPlanModule-module__font-s-28___UC2Om`,
	"fontW400": `WellnessPlanModule-module__font-w-400___vyLkJ`,
	"fontW500": `WellnessPlanModule-module__font-w-500___njaAD`,
	"fontW600": `WellnessPlanModule-module__font-w-600___dtQvt`,
	"fontW700": `WellnessPlanModule-module__font-w-700___o0OTS`,
	"p5": `WellnessPlanModule-module__p-5___K2kO3`,
	"p12": `WellnessPlanModule-module__p-12___Xg3oz`,
	"p16": `WellnessPlanModule-module__p-16___isjL5`,
	"p30": `WellnessPlanModule-module__p-30___JpzYP`,
	"pB0": `WellnessPlanModule-module__p-b-0___v5YR0`,
	"pB5": `WellnessPlanModule-module__p-b-5___aicqI`,
	"pB10": `WellnessPlanModule-module__p-b-10___ihSW9`,
	"pB12": `WellnessPlanModule-module__p-b-12___oQRSM`,
	"pB16": `WellnessPlanModule-module__p-b-16___zF_OH`,
	"pB18": `WellnessPlanModule-module__p-b-18___ig4ku`,
	"pB20": `WellnessPlanModule-module__p-b-20___bIMD0`,
	"pB25": `WellnessPlanModule-module__p-b-25___aC5nK`,
	"pB30": `WellnessPlanModule-module__p-b-30___D948J`,
	"pB50": `WellnessPlanModule-module__p-b-50___dB07H`,
	"pT0": `WellnessPlanModule-module__p-t-0___uRlov`,
	"pT12": `WellnessPlanModule-module__p-t-12___Mm6dg`,
	"pT16": `WellnessPlanModule-module__p-t-16___o3ktI`,
	"pT18": `WellnessPlanModule-module__p-t-18___W_tMr`,
	"pT20": `WellnessPlanModule-module__p-t-20___R4yAa`,
	"pT30": `WellnessPlanModule-module__p-t-30___NHiQP`,
	"pT40": `WellnessPlanModule-module__p-t-40___UzToZ`,
	"pT50": `WellnessPlanModule-module__p-t-50___B9aSC`,
	"pL20": `WellnessPlanModule-module__p-l-20___xU0d2`,
	"pL30": `WellnessPlanModule-module__p-l-30___KaGYR`,
	"pL40": `WellnessPlanModule-module__p-l-40___gM3em`,
	"pR16": `WellnessPlanModule-module__p-r-16___v9G3B`,
	"pR20": `WellnessPlanModule-module__p-r-20___xsgpc`,
	"pR30": `WellnessPlanModule-module__p-r-30___r88UJ`,
	"pR50": `WellnessPlanModule-module__p-r-50___d8qqB`,
	"pR60": `WellnessPlanModule-module__p-r-60___cz8UQ`,
	"mB1": `WellnessPlanModule-module__m-b-1___qpXRu`,
	"mB2": `WellnessPlanModule-module__m-b-2___pCRd_`,
	"mB6": `WellnessPlanModule-module__m-b-6___R3QPb`,
	"mB8": `WellnessPlanModule-module__m-b-8____ncu1`,
	"mB10": `WellnessPlanModule-module__m-b-10___fprV1`,
	"mB14": `WellnessPlanModule-module__m-b-14___I7vbQ`,
	"mB16": `WellnessPlanModule-module__m-b-16___m42ix`,
	"mB20": `WellnessPlanModule-module__m-b-20___vA3e5`,
	"mB22": `WellnessPlanModule-module__m-b-22___ywKSi`,
	"mB24": `WellnessPlanModule-module__m-b-24___UPv7P`,
	"mB30": `WellnessPlanModule-module__m-b-30___tPTuY`,
	"mB32": `WellnessPlanModule-module__m-b-32___MNVug`,
	"mB40": `WellnessPlanModule-module__m-b-40___siCFR`,
	"mT2": `WellnessPlanModule-module__m-t-2___Sn104`,
	"mT3": `WellnessPlanModule-module__m-t-3___NoTMD`,
	"mT4": `WellnessPlanModule-module__m-t-4___r5PYo`,
	"mT5": `WellnessPlanModule-module__m-t-5___lBDnz`,
	"mT8": `WellnessPlanModule-module__m-t-8___QCn6X`,
	"mT10": `WellnessPlanModule-module__m-t-10___k7nnE`,
	"mT15": `WellnessPlanModule-module__m-t-15___S_ZVP`,
	"mT16": `WellnessPlanModule-module__m-t-16___HKICM`,
	"mT20": `WellnessPlanModule-module__m-t-20___uO9Zt`,
	"mT22": `WellnessPlanModule-module__m-t-22___cTp0A`,
	"mT30": `WellnessPlanModule-module__m-t-30___wOyC5`,
	"mT32": `WellnessPlanModule-module__m-t-32___KJ5WX`,
	"mLAuto": `WellnessPlanModule-module__m-l-auto___YXT_a`,
	"mL4": `WellnessPlanModule-module__m-l-4___Lo68e`,
	"mL5": `WellnessPlanModule-module__m-l-5___I_P_P`,
	"mL6": `WellnessPlanModule-module__m-l-6___EOug_`,
	"mL8": `WellnessPlanModule-module__m-l-8___orrF5`,
	"mL10": `WellnessPlanModule-module__m-l-10___mkkXA`,
	"mL16": `WellnessPlanModule-module__m-l-16___KdQSI`,
	"mL20": `WellnessPlanModule-module__m-l-20___UFur0`,
	"mL24": `WellnessPlanModule-module__m-l-24___dSJAd`,
	"mL30": `WellnessPlanModule-module__m-l-30___gZYlH`,
	"mL35": `WellnessPlanModule-module__m-l-35___L96EO`,
	"mL40": `WellnessPlanModule-module__m-l-40___lZDsN`,
	"mR8": `WellnessPlanModule-module__m-r-8___cy1o8`,
	"mR10": `WellnessPlanModule-module__m-r-10___sjtIz`,
	"mR16": `WellnessPlanModule-module__m-r-16___tjYBg`,
	"mR20": `WellnessPlanModule-module__m-r-20___N2koR`,
	"mR24": `WellnessPlanModule-module__m-r-24___Y1ume`,
	"mR30": `WellnessPlanModule-module__m-r-30___mCqXq`,
	"mR40": `WellnessPlanModule-module__m-r-40___ErCls`,
	"borderR3": `WellnessPlanModule-module__border-r-3___C_bGj`,
	"borderR4": `WellnessPlanModule-module__border-r-4___iYOme`,
	"borderR6": `WellnessPlanModule-module__border-r-6___cJlr5`,
	"borderR10": `WellnessPlanModule-module__border-r-10___Ya0SH`,
	"borderR12": `WellnessPlanModule-module__border-r-12___m_5uP`,
	"borderR16": `WellnessPlanModule-module__border-r-16___FKa6g`,
	"borderR50": `WellnessPlanModule-module__border-r-50___dgTVd`,
	"primaryBorder": `WellnessPlanModule-module__primary-border___bA8ku`,
	"primaryBorderB": `WellnessPlanModule-module__primary-border-b___gJaYG`,
	"primaryBorderT": `WellnessPlanModule-module__primary-border-t___SlIIv`,
	"primaryBorderL": `WellnessPlanModule-module__primary-border-l___hSH7A`,
	"primaryBorderR": `WellnessPlanModule-module__primary-border-r___AjJI6`,
	"secondaryBorder": `WellnessPlanModule-module__secondary-border___ygeBC`,
	"secondaryBorderB": `WellnessPlanModule-module__secondary-border-b___AQuhB`,
	"secondaryBorderT": `WellnessPlanModule-module__secondary-border-t___G61p4`,
	"secondaryBorderL": `WellnessPlanModule-module__secondary-border-l___TmDay`,
	"secondaryBorderR": `WellnessPlanModule-module__secondary-border-r___LLamk`,
	"gap0": `WellnessPlanModule-module__gap-0___bfDkh`,
	"gap2": `WellnessPlanModule-module__gap-2___yyjBC`,
	"gap4": `WellnessPlanModule-module__gap-4___Cq9J9`,
	"gap5": `WellnessPlanModule-module__gap-5___FgNOs`,
	"gap6": `WellnessPlanModule-module__gap-6___uL5Cu`,
	"gap8": `WellnessPlanModule-module__gap-8___xzSk0`,
	"gap10": `WellnessPlanModule-module__gap-10___EVwue`,
	"gap12": `WellnessPlanModule-module__gap-12___tR_wa`,
	"gap14": `WellnessPlanModule-module__gap-14___U4HOq`,
	"gap16": `WellnessPlanModule-module__gap-16___SwpkQ`,
	"gap18": `WellnessPlanModule-module__gap-18___eHfZJ`,
	"gap20": `WellnessPlanModule-module__gap-20___nd6dT`,
	"gap24": `WellnessPlanModule-module__gap-24___RfNlA`,
	"gap26": `WellnessPlanModule-module__gap-26___mF179`,
	"gap30": `WellnessPlanModule-module__gap-30___BozC5`,
	"gap32": `WellnessPlanModule-module__gap-32___tCErU`,
	"gap40": `WellnessPlanModule-module__gap-40___Fz9Dy`,
	"gap50": `WellnessPlanModule-module__gap-50___OpuOk`,
	"flex1": `WellnessPlanModule-module__flex-1___EC4J4`,
	"flexNone": `WellnessPlanModule-module__flex-none___HB_pI`,
	"flexColumn": `WellnessPlanModule-module__flex-column___v0EHb`,
	"flexRow": `WellnessPlanModule-module__flex-row___vHT_5`,
	"verticallyCentered": `WellnessPlanModule-module__vertically-centered___TI5U9`,
	"horizontallyCentered": `WellnessPlanModule-module__horizontally-centered___FVGC_`,
	"horizontallyEnd": `WellnessPlanModule-module__horizontally-end___zuij4`,
	"verticallyStart": `WellnessPlanModule-module__vertically-start___P26L3`,
	"spaceBetween": `WellnessPlanModule-module__space-between___A1PEK`,
	"flexWrap": `WellnessPlanModule-module__flex-wrap___W5bnd`,
	"height100": `WellnessPlanModule-module__height-100___EuZjr`,
	"width50": `WellnessPlanModule-module__width-50___zhCZV`,
	"width100": `WellnessPlanModule-module__width-100___IjNmR`,
	"cursorPointer": `WellnessPlanModule-module__cursor-pointer___OKekO`,
	"cursorNotAllowed": `WellnessPlanModule-module__cursor-not-allowed___EkPTt`,
	"absoluteCentered": `WellnessPlanModule-module__absolute-centered___hQyCf`,
	"absolute": `WellnessPlanModule-module__absolute___hnvE9`,
	"relative": `WellnessPlanModule-module__relative___foZo6`,
	"fixed": `WellnessPlanModule-module__fixed___jHmsd`,
	"visible": `WellnessPlanModule-module__visible___VhBv_`,
	"invisible": `WellnessPlanModule-module__invisible___soK65`,
	"col90": `WellnessPlanModule-module__col-90___iHaNQ`,
	"colAuto": `WellnessPlanModule-module__col-auto___BvFhu`,
	"medicalTabs": `WellnessPlanModule-module__medical-tabs___m8aFj`,
	"medicalTableNew": `WellnessPlanModule-module__medical-table-new___GTqAa`,
	"noPagination": `WellnessPlanModule-module__no-pagination___zBEA6`,
	"medicalTableEmpty": `WellnessPlanModule-module__medical-table-empty___GCN0P`,
	"iconBtn": `WellnessPlanModule-module__icon-btn___VwKEg`,
	"searchIcon": `WellnessPlanModule-module__search-icon___r50CQ`,
	"disableSelect": `WellnessPlanModule-module__disable-select___MCb3U`,
	"breakWord": `WellnessPlanModule-module__break-word___TgAQB`,
	"popupClearBtn": `WellnessPlanModule-module__popup-clear-btn___VR_R8`,
	"scrollMB20": `WellnessPlanModule-module__scroll-m-b-20___OqDMY`,
	"container": `WellnessPlanModule-module__container___cb2X7`
};
module.exports = ___CSS_LOADER_EXPORT___;
